(() => {
  const homeHero: HTMLDivElement | null = document.querySelector(
    ".home-hero.is-animated-hover"
  );

  if (homeHero) {
    const homeHeroParts: NodeListOf<SVGPathElement> =
      homeHero.querySelectorAll(".home-hero__part");

    homeHeroParts.forEach((homeHeroPart: SVGPathElement) => {
      const { color } = homeHeroPart.dataset;

      if (color) {
        homeHeroPart.addEventListener("mouseover", () => {
          homeHero.classList.add(`is-${color}`);
        });

        homeHeroPart.addEventListener("mouseout", () => {
          homeHero.classList.remove(`is-${color}`);
        });
      }
    });
  }
})();

/* (() => {
  window.addEventListener("mousemove", (event: MouseEvent) => {
    const paths: NodeListOf<SVGPathElement> = document.querySelectorAll(".pulsing-path");
    const { clientX } = event;

    paths.forEach(path => {
      const { intensity } = path.dataset;

      if (intensity) {
        const { innerWidth: width } = window;
        const scale = 1 + ((width / 2 - clientX) * parseFloat(intensity) * .1);

        if (path) {
          path.style.setProperty("--scale", `${scale}`);
        }
      }
    });
  });

  window.addEventListener("mouseout", () => {
    const path: SVGPathElement | null = document.querySelector(".pulsing-path");

    if (path) {
      path.style.setProperty("--x", "0px");
      path.style.setProperty("--y", "0px");
    }
  });
})(); */

export {};
